module.exports = __webpack_public_path__ + "img/12.daab4873.jpg";